export default "__VITE_ASSET__nfQiMWqF__"